module.exports = __webpack_public_path__ + "img/download.0bb43402.svg";